import { render, staticRenderFns } from "./textareaEditor.vue?vue&type=template&id=45e6bc86"
import script from "./textareaEditor.vue?vue&type=script&lang=js"
export * from "./textareaEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports